import { API, authClient } from "../index";

export const postUser = async (user, accessToken) => {
	return authClient(accessToken).post(`${API}/users`, user);
};

export const getUsers = (accessToken) => {
	return authClient(accessToken).get(`${API}/users`);
};

export const getUserById = (id, accessToken) => {
	return authClient(accessToken).get(`${API}/users/${id}`);
};

export const updateUser = async (id, user, accessToken) => {
	return authClient(accessToken).put(`${API}/users/${id}`, user);
};

export const changeStatusUser = async (id, active, accessToken) => {
	return authClient(accessToken).put(
		`${API}/users/${id}/status?active=${active}`
	);
};

export const deleteUser = (id, accessToken) => {
	return authClient(accessToken).delete(`${API}/users/${id}`);
};
